
const url=process.env.REACT_APP_ENV==="production"?"https://nuecruit.nuearcus.com":process.env.REACT_APP_API_URL
const ragUrl=process.env.REACT_APP_ENV==="production"?"https://nuecruit.nuearcus.com":process.env.REACT_APP_API_RAGURL


async function FetchKnowledgeChart(data)
{
   console.log(data);
    try{
         const response =await fetch(`${url}/api/charts/knowledge`,{ method:'POST',headers:{
            'Content-Type':'application/json' }, 
           body:JSON.stringify({userID:data}),
         })
         if(response.ok)
         {
            const body=await response.json();
            
            console.log(body,'body');
            return body;
         }
         const error=await response.json();

         return error;   
    }   
    catch(error)
    {
        return error;
    } 
}

async function FetchPschometricChart(data)
{
   console.log(data);
    try{
         const response =await fetch(`${url}/api/charts/pyschometric`,{ method:'POST',headers:{
            'Content-Type':'application/json' }, 
           body:JSON.stringify({userID:data}),
         })
         if(response.ok)
         {
            const body=await response.json();
            
            console.log(body,'body');
            return body;
         }
         const error=await response.json();

         return error;   
    }   
    catch(error)
    {
        return error;
    } 
}
const FetchTags=async ()=>{
   try{
      const response=await fetch(`${url}/api/admin/fetchtags`)
      if(response.ok)
      {
          const data=await response.json();
          // console.log(data);
          return data;
      }
   }
   catch(error)
   {
         return 'network error',error
   }
}

const FetchAreas=async ()=>{
   try{
      const response=await fetch(`${ragUrl}/api/admin/ragQA/areas`)
      if(response.ok)
      {
          const data=await response.json();
          console.log('areas',data);
          return data;
      }
   }
   catch(error)
   {
         return 'network error',error
   }
}


export {FetchKnowledgeChart,FetchTags,FetchPschometricChart,FetchAreas};